import { render, staticRenderFns } from "./VolunteerCard.vue?vue&type=template&id=983b5992&scoped=true&"
import script from "./VolunteerCard.vue?vue&type=script&lang=js&"
export * from "./VolunteerCard.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerCard.vue?vue&type=style&index=0&id=983b5992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983b5992",
  null
  
)

export default component.exports